import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { Chart } from "chart.js";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function MonthColumnchart() {
  const [radarData, setRadarData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const storedUserData = localStorage.getItem("userData");
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    groupId = userData.groupId;
  }

  const [currency, setCurrency] = useState("");
  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
        console.log(data);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetCrAndDRYearwise?groupId=${groupId}&year=${selectedYear}`
        );
        const data = await response.json();
        setRadarData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    if (radarData.length === 0) {
      // Display a message or handle no data scenario
      return;
    }
    if (window.radarchart) {
      window.radarchart.destroy();
    }

    const config = {
      type: "radar",
      data: {
        labels: radarData.map((item) => monthNames[item.month - 1]), // Convert month number to month name
        datasets: [
          {
            label: "Total Credit",
            data: radarData.map((item) => item.totalCredit),
            backgroundColor: "rgba(75, 192, 192, 0.2)", // Fill color
            borderColor: "rgba(75, 192, 192, 1)", // Border color
            borderWidth: 2,
          },
          {
            label: "Total Debit",
            data: radarData.map((item) => item.totalDebit),
            backgroundColor: "rgba(192, 75, 192, 0.2)", // Fill color
            borderColor: "rgba(192, 75, 192, 1)", // Border color
            borderWidth: 2,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: "Expense Distribution",
        },
        scale: {
          ticks: { beginAtZero: true },
        },
        plugins: {
          datalabels: {
            display: false,
            color: "brown", // Font color for labels
            font: {
              weight: "bold", // Bold font weight
              size: 14, // Font size in pixels
              family: "Courier",
            },
            formatter: (value) => {
              // Custom label formatter function to display only value
              return value;
            },
          },
        },
      },
    };

    const ctx = document.getElementById("radar-chart").getContext("2d");
    window.radarchart = new Chart(ctx, config);
  }, [radarData]);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex items-center justify-between">
            <h2
              className="text-blueGray-700 text-xl font-semibold"
              style={{ fontSize: "1rem" }}
            >
              Yearly Credit And Debit ({currency})
            </h2>
            <select
              className="bg-white-800 text-black border border-black-600 rounded px-6 py-1 outline-none focus:outline-none w-32"
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}
            >
              {Array.from({ length: 5 }, (_, i) => (
                <option key={i} value={new Date().getFullYear() - i}>
                  {new Date().getFullYear() - i}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="p-4 flex-auto">
          <div className="relative h-350-px">
            <canvas id="radar-chart"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
